<template>
    <v-main
            app
            color="primary"
            dark
    >
        <v-container
                class="fill-height"
                fluid
        >
            <v-row
                    justify="center"
                    align="center"
            >
                <v-col cols=12 class="text-center">
                    <v-img
                            :src="require('@/assets/cube.png')"
                            class="my-3"
                            contain
                            height="240"
                    />
                    <h1 class="display-2 font-weight-bold blue-grey--text text--lighten-2">
                        #enishi
                    </h1>
                    <h3 class="font-weight-thin blue-grey--text text--lighten-2">
                        すき間に つめこもう
                    </h3>
                </v-col>
                <v-col cols=12 class="text-center">
                </v-col>
                <v-col cols=12 class="text-center">
                    <button class="googleLogin" @click="login" v-if="!userStatus && authChecked">
                        <v-img
                                :src="require('@/assets/btn_google_signin_dark_normal_web@2x.png')"
                                contain
                                width="191"
                                height="46"
                        />
                        <v-img
                                :src="require('@/assets/btn_google_signin_dark_focus_web@2x.png')"
                                class="active"
                                contain
                                width="191"
                                height="46"
                        />
                    </button>

                </v-col>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>
    import firebase from '@/plugins/firebase.js';

    export default {
        name: "Splash",
        computed: {
            user() {
                return this.$store.getters.user;
            },
            userStatus() {
                return this.$store.getters.isSignedIn;
            },
            authChecked() {
                return this.$store.getters.authChecked;
            }
        },
        methods: {
            login: function () {
                firebase.login();
            }
        },
    }
</script>

<style scoped>
    .googleLogin {
        position: relative;
    }
    .googleLogin .active {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        transition: 0.5s;
    }
    .googleLogin:hover .active {
        opacity: 1;
    }
</style>
